import { baseApi } from './baseApi'
import type {
	OptionsRes,
	PostOptionReq,
	PostNewOptionReq,
	DeleteOptionReq,
} from '../../types'

export const optionsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getOptions: builder.query<OptionsRes, void>({
			query: () => ({
				url: '/data/options',
				method: 'GET',
			}),
			providesTags: ['Option'],
		}),

		changeOption: builder.mutation<
			{ message?: string; data?: unknown },
			PostOptionReq
		>({
			query: ({ params, data }) => ({
				url: `/data/options/${params.option}/${params.option_code}`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['Option'],
		}),

		addOption: builder.mutation<
			{ message?: string; data?: unknown },
			PostNewOptionReq
		>({
			query: ({ params, data }) => ({
				url: `/data/options/${params.option}`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['Option'],
		}),

		deleteOption: builder.mutation<
			{ message?: string },
			DeleteOptionReq
		>({
			query: ({ option, option_code }) => ({
				url: `/data/options/${option}/${option_code}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Option'],
		}),
	}),
})

export const {
	useGetOptionsQuery,
	useChangeOptionMutation,
	useAddOptionMutation,
	useDeleteOptionMutation,
} = optionsApi

